import React from "react"
import TimeActionBar from "./TimeActionBar"
import { TimeBarViewType, EDayOfWeek } from "../../../models"
import { SelectField, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
interface IProps {
  startDayOfWeek: EDayOfWeek
  referenceDate: Date | string
  timeBarViewType: TimeBarViewType
  handleChangeTimeRange(startDate: string, endDate: string): void
  handleChangeViewType(viewType: TimeBarViewType): void
}

const WeeklyMonthlyTimeActionBar: React.SFC<IProps> = (props: IProps) => {
  return (
    <div style={{ display: "flex" }}>
      <div style={{ flex: 1 }}>
        <TimeActionBar
          referenceDate={props.referenceDate}
          handleChangeTimeRange={props.handleChangeTimeRange}
          startDayOfWeek={props.startDayOfWeek}
          timeBarViewType={props.timeBarViewType}
        />
      </div>
      <div>
        <SelectField
          data-intercom-target={"TimeAction-Select-View"}
          floatingLabelText={strings.Week_Month}
          value={props.timeBarViewType}
          onChange={(event, index, value) => props.handleChangeViewType(value)}
          style={{ marginTop: -17, marginRight: 35, width: 175 }}
        >
          <MenuItem value={"week"} primaryText={strings.Week_View} />
          <MenuItem value={"month"} primaryText={strings.Month_View} />
        </SelectField>
      </div>
    </div>
  )
}

export default WeeklyMonthlyTimeActionBar